<script setup>
import AddNewRulesInput from './AddNewRulesInput.vue';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  title: { type: String, required: true },
  helper: { type: String, required: true },
  placeholder: { type: String, required: true },
});

const rules = defineModel({ type: Array, default: () => [] });

const addRule = content => {
  if (!rules.value.includes(content)) rules.value = [...rules.value, content];
};

const editRule = (id, content) => {
  rules.value = rules.value.map((rule, index) => (index === id ? content : rule));
};

const deleteRule = id => {
  rules.value = rules.value.filter((_, index) => index !== id);
};
</script>

<template>
  <section class="flex flex-col gap-2">
    <h4 class="m-0 text-body-small font-medium text-n-slate-12">
      {{ title }}
    </h4>
    <p class="m-0 text-body-small text-n-slate-11">{{ helper }}</p>
    <div
      v-for="(rule, index) in rules"
      :key="index"
      class="flex items-start gap-2"
    >
      <textarea
        :value="rule"
        :aria-label="title"
        rows="2"
        class="flex-1 rounded-md border border-n-strong bg-n-background px-3 py-2 text-n-slate-12"
        @input="editRule(index, $event.target.value)"
      />
      <Button
        icon="i-lucide-trash"
        :aria-label="$t('TEAMS_SETTINGS.DELETE.BUTTON_TEXT')"
        variant="ghost"
        @click="deleteRule(index)"
      />
    </div>
    <AddNewRulesInput
      :placeholder="placeholder"
      :label="$t('CAPTAIN.ASSISTANTS.GUARDRAILS.ADD.SUGGESTED.ADD_SINGLE')"
      @add="addRule"
    />
  </section>
</template>
